// Components
import { RootState } from '../index';

const getAuthInfo = (state: RootState) => state.profileDataSlice.auth_info;

const getProfileInfo = (state: RootState) => state.profileDataSlice.profile_info;

const getBiometricDataInfo = (state: RootState) => state.profileDataSlice.biometric_data_info;

export {
  getAuthInfo,
  getProfileInfo,
  getBiometricDataInfo
};
